import { useState, useEffect } from 'react';
import { adminApi, ApiError } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

interface AdminStatus {
  isAdmin: boolean;
  adminLevel?: number;
  loading: boolean;
  error: string | null;
}

export const useAdmin = (): AdminStatus => {
  const { user } = useAuth();
  const [adminStatus, setAdminStatus] = useState<AdminStatus>({
    isAdmin: false,
    loading: true,
    error: null,
  });

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (!user) {
        setAdminStatus({
          isAdmin: false,
          loading: false,
          error: null,
        });
        return;
      }

      try {
        setAdminStatus(prev => ({ ...prev, loading: true, error: null }));
        const response = await adminApi.checkAdminStatus();
        setAdminStatus({
          isAdmin: response.is_admin,
          adminLevel: response.admin_level,
          loading: false,
          error: null,
        });
      } catch (error) {
        if (error instanceof ApiError) {
          setAdminStatus({
            isAdmin: false,
            loading: false,
            error: error.message,
          });
        } else {
          setAdminStatus({
            isAdmin: false,
            loading: false,
            error: 'Failed to check admin status',
          });
        }
      }
    };

    checkAdminStatus();
  }, [user]);

  return adminStatus;
};